export default class Text {
    constructor(idioma) {
        this.idioma = idioma || 'br'
    }

    getTextoHeader() {
        switch (this.idioma) {
            case 'br':
                return [
                    `Sistemas customomizados para automatizar processos manuais, transformar serviços manuais em digitais e melhorar a gestão`,
                    `Projetos para instalação ou adequação de cabeamento estruturado em redes de dados, voz e elétrica`,
                    `O site da sua empresa precisa ser muito mais que um simples cartão de visitas online, deve ser uma maneira de potencializar as vendas e fortalecer sua marca`,
                    `Gerenciamento do seu negócio através de implantação de servidores para arquivos, aplicações corporativas e controladores de domínio`,
                    `Atuamos no desenvolvimento rápido de apps para startups testarem ideias e na construção de apps robustos para empresas consolidadas`,
                    `Projeto e instalação de sistemas de alarme que identificam anormalidades que possam ocorrer no ambiente`,
                    `Instalação e configuração de sistemas de segurança por monitoramento e gravação de imagens com câmeras digitais e analógicas`,
                    `Realizamos suporte, manutenção e evolução para softwares já customizados e em utilização para melhorar a experiência do usuário`
                ]
            case 'us':
                return [
                    `Customized systems to automate manual tasks, transform manual and digital services and improve the managing`,
                    `Projects for installation or improvement of structured cabling for data, voice and eletric networks`,
                    `Your business' site must be much more than an online business card, it must be a way to increase your selling and strengthen your brand`,
                    `Manage your business by setting up storage services for files, corporative applications and domain controllers`,
                    `We develop small and fast apps for startups testing their ideas and also robust apps for consolidated companies`,
                    `We perform project and installation for alarms systems made of equipment capable of identifying abnormalities that may occur on the environment`,
                    `Installation and configuration of security systems with monitoring and image recording with analogical and digital cameras`,
                    `For running softwares, our team meets the need for maintenance and evolution, performing improvements to improve user experience`
                ]
            default:
                return `Undefined Language`
        }
    }

    getTextoHome1() {
        switch (this.idioma) {
            case 'br':
                return `Somos uma empresa brasileira de prestação de serviços que atua no mercado de TI. A excelência no relacionamento com parceiros de diferentes níveis de maturidade e até mesmo na identificação das novas tendências do mercado credencia a`
            case 'us':
                return `City Connect is a Brazilian service company that operates in the IT market. In its own portfolio, it houses a significant number of city halls, nongovernmental organizations, institutes, municipalities, companies and factories.`
            default:
                console.log('Idioma não referenciado')
        }
    }

    getTextoApp() {
        switch (this.idioma) {
            case 'br':
                return [
                    `Desenvolvimento de Aplicativos`,
                    `Criamos aplicativos totalmente customizáveis para empresas de todos os tamanhos`
                ]
            case 'us':
                return [
                    `Apps Development`,
                    `We make totally customizable apps for any sized business`
                ]
            default:
                console.log('Idioma não referenciado')
        }
    }

    getManutencao() {
        switch (this.idioma) {
            case 'br':
                return [
                    `Manutenção e Evolução`,
                    `Realizamos a manutenção de projetos já existentes e os aperfeiçoamos para nossos clientes`
                ]
            case 'us':
                return [
                    `Maintenance and Improvement`,
                    `We offer support for running projects and improvements to meet our clients' needs`
                ]
            default:
                console.log('Idioma não referenciado')
        }
    }

    getSites() {
        switch (this.idioma) {
            case 'br':
                return [
                    `Desenvolvimento de Sites`,
                    `Criamos websites customizáveis para atender as necessidades de cada tipo de cliente`
                ]
            case 'us':
                return [
                    `Websites Development`,
                    `We create fully customizable websites to meet the needs of each type of client`
                ]
            default:
                console.log('Idioma não referenciado')
        }
    }

    getSistemas() {
        switch (this.idioma) {
            case 'br':
                return [
                    `Desenvolvimento de Sistemas`,
                    `Desenvolvemos sistemas para automatizar serviços e melhorar a gestão`
                ]
            case 'us':
                return [
                    `Websites Development`,
                    `We develop systems for automate services and improve management`
                ]
            default:
                console.log('Idioma não referenciado')
        }
    }

    getTextoMoreServices() {
        switch (this.idioma) {
            case 'br':
                return `NOSSOS SERVIÇOS`
            case 'us': 
                return `OUR SERVICES`
            default:
                return `Undefined Language`
        }
    }

    getTextoRodape() {
        switch (this.idioma) {
            case 'br':
                return `As diretrizes e politicas de privacidade de informações de nossos clientes são entendidas como prioridade por toda equipe da City Connect. Desta forma nçao cedemos informações referentes a nossos clientes a terceiros.`
            case 'us':
                return `
                Our customers' information privacy policies and guidelines are understood as a priority by the entire City Connect team. In this way we do not give information about our customers to third parties.`
            default:
                    console.log('Idioma não referenciado')
        }
    }

    getDireitosReservados() {
        switch (this.idioma) {
            case 'br':
                return `Todos os direitos reservados - @ City Connect`
            case 'us':
                return `All rights reserved - @ City Connect`
            default:
                    console.log('Idioma não referenciado')
        }
    }

    getTextoKnowMore() {
        switch (this.idioma) {
            case 'br':
                return [
                    `QUER SABER MAIS?`,
                    `VAMOS CONVERSAR`
                ]
            case 'us':
                return [
                    `WANT TO KNOW MORE?`,
                    `LET'S TALK`
                ]
            default:
                    console.log('Idioma não referenciado')
        }
    }

    getOsSystem() {
        switch (this.idioma) {
            case 'br': 
                return `Sistema de OS`
            case 'us':
                return `OS System`
            default: 
                return `Undefined Language`
        }        
    }

    getPassword() {
        
        switch (this.idioma) {
            case 'br':
                return `senha`
            case 'us':
                return `password`
            default:
                return `Undefined Language`
        }
    }

    getUsername() {
        switch (this.idioma) {
            case 'br':
                return `nome de usuário`
            case 'us':
                return `username`
            default:
                return `Undefined Language`
        }
    }

    getLogin() {
        switch (this.idioma) {
            case 'br':
                return `Entrar`
            case 'us':
                return `Sign in`
            default:
                return `Undefined Language`
        }
    }

    getTextWeWant() {
        switch (this.idioma) {
            case 'br':
                return `QUEREMOS LHE OFERECER O QUE HÁ DE MELHOR EM INOVAÇÕES TECNOLÓGICAS`
            case 'us':
            return `WE OFFER YOU THE BEST IN TECHNOLOGICAL INNOVATIONS`
            default:
                return `Undefined Languange`
        }
    }

    getDepartment() {
        switch (this.idioma) {
            case 'br':
                return [
                    'DESENVOLVIMENTO',
                    'INFRAESTRUTURA'
                ]
            case 'us':
                return [
                    'DEVELOPMENT',
                    'INFRASTRUCTURE'
                    ]
            default:
                return `Undefined Languange`
        }
    }

    getAlarme() {
        switch (this.idioma) {
            case 'br':
                return [
                    'Alarme e Controle de Acesso',
                    'Instalação e configuração de alarmes e sistemas de controle de acesso para estabelecimentos e residências'
                ]
            case 'us':
                return [
                    'Alarm and Access Control',
                    'Installation and configuration of alarms and access control systems for business and residences'
                    ]
            default:
                return `Undefined Languange`
        }
    }

    getServidor() {
        switch (this.idioma) {
            case 'br':
                return [
                    'Gerenciamento de Servidores Físicos e Virtuais',
                    'Gerenciamento do seu negócio através servidores para arquivos, aplicações corporativas e controladores de domínio'
                ]
            case 'us':
                return [
                    'Management of Physical and Virtual Servers',
                    'Manage your business throw servers for your files, corporative applications and domain controllers'
                    ]
            default:
                return `Undefined Languange`
        }
    }

    getCamera() {
        switch (this.idioma) {
            case 'br':
                return [
                    'Sistemas de Monitoramento e Gravação',
                    'Implantamos sistemas de segurança por câmeras digitais e analógicas'
                ]
            case 'us':
                return [
                    'Monitoring and Record Systems',
                    'We perform installation of security systems with analogical and digital cameras'
                    ]
            default:
                return `Undefined Languange`
        }
    }

    getCabeamento() {
        switch (this.idioma) {
            case 'br':
                return [
                    'Cabeamento Estruturado',
                    'Realizamos projetos para instalação ou adequação de cabeamento estruturado de rede, voz e elétrico'
                ]
            case 'us':
                return [
                    'Structured Cabling',
                    'We make projects for installation or improvements for network, voice and eletric structured cabling'
                    ]
            default:
                return `Undefined Languange`
        }
    }

    getDevBenefits() {
        switch (this.idioma) {
            case 'br':
                return [
                    'POTENCIALIZAÇÃO DE VENDAS',
                    'FORTALECIMENTO DA MARCA',
                    'INTEGRAÇÃO DE SOFTWARES'
                ]
            case 'us':
                return [
                    'SELLING ENHANCEMENT',
                    'BRAND STRENGTHENING',
                    'SOFTWARES INTEGRATION'
                    ]
            default:
                return `Undefined Languange`
        }
    }

    getInfraBenefits() {
        switch (this.idioma) {
            case 'br':
                return [
                    'AGILIDADE E AUTOMATIZAÇÃO DE PROCESSOS',
                    'SEGURANÇA E ORGANIZAÇÃO DE DADOS',
                    'REDUÇÃO DE GASTOS'
                ]
            case 'us':
                return [
                    'AGILITY AND AUTOMATION FOR PROCESSES ',
                    'DATA SECURITY AND ORGANIZATION',
                    'SPENDING DECREASE'
                    ]
            default:
                return `Undefined Languange`
        }
    }
}